<template>
<div>
	<div>
		<div>
			<h2 class="page-header" v-if="!IsModal">
				<span id="page-header">{{ pageheader }}</span>
				<a href="/deceaseds/" class="hidden-md hidden-lg"><button class="btn btn-success">Zur Liste</button></a>
			</h2>

			<div class="row">
				<h3 class="col-lg-12">Persönliche Informationen  <router-link class="btn btn-primary create-new pull-right" to="/deceaseds/new"><i class="fa fa-plus"></i></router-link></h3>
				<div class="form-horizontal" id="customer-information">

					<div class="row">
						<div class="col-md-4">
							<custom-input inline>
								<label class="col-md-12 control-label" for="firstname">Vorname <span style="color: #f00; font-weight: 800">*</span></label>
								<div class="col-md-12">
									<input name="firstname" id="firstname" class="form-control" v-model="model.model.firstname" required>
								</div>
							</custom-input>
						</div>

						<div class="col-md-4">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="lastname">Nachname <span style="color: #f00; font-weight: 800">*</span></label>
								<div class="col-sm-12">
									<input name="lastname" id="lastname" class="form-control" v-model="model.model.lastname" required>
								</div>
							</custom-input>
						</div>

						<div class="col-md-4">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="birthname">Geburtsname</label>
								<div class="col-sm-12">
									<input name="birthname" id="birthname" class="form-control" v-model="model.model.birthname" required>
								</div>
							</custom-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-4">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="birthplace">Geburtsort</label>
								<div class="col-sm-12">
									<input name="birthplace" id="birthplace" class="form-control" v-model="model.model.birthplace" required>
								</div>
							</custom-input>
						</div>

						<div class="col-md-4">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="denomination">Konfession</label>
								<div class="col-sm-12">
									<!-- <div class="input-group">
										<input id="denomination" name="denomination" class="form-control" required="required" v-model="model.model.denomination" readonly="readonly">
										<span class="input-group-addon addon-primary" @click="selectDenomination()"><i class="fa fa-pencil"></i></span>
									</div> -->
									<select name="burial_type" id="denomination" class="form-control" v-model="model.model.denomination_id">
										<option :value="0">[Keine Konfession]</option>
										<option v-for="type in $store.getters.models('denominations')" :value="type.id">{{ type.name }}</option>
									</select>
								</div>
							</custom-input>
						</div>

						<div class="col-md-4">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="lastname">Geschlecht <span style="color: #f00; font-weight: 800">*</span></label>
								<div class="col-sm-12">
									<select name="gender" class="form-control" v-model="model.model.gender">
										<option :value="0">[Bitte wählen]</option>
										<option :value="1">männlich</option>
										<option :value="2">weiblich</option>
										<option :value="3">transgender</option>
									</select>
								</div>
							</custom-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-3">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="birthday">Geburtstag <span style="color: #f00; font-weight: 800">*</span></label>
								<div class="col-sm-12">
									<datepicker id="birthday" bootstrapStyling calendar-button calendar-button-icon="fa fa-calendar" name="birthday" v-model="model.model.birthday" required language="de" format="yyyy-MM-dd"></datepicker>
								</div>
							</custom-input>
						</div>

						<div class="col-md-3">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="dyingday">Todestag <span style="color: #f00; font-weight: 800">*</span></label>
								<div class="col-sm-12">
									<datepicker id="dyingday" bootstrapStyling calendar-button calendar-button-icon="fa fa-calendar" name="dyingday" v-model="model.model.dyingday" required language="de" format="yyyy-MM-dd"></datepicker>
								</div>
							</custom-input>
						</div>

						<div class="col-md-3">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="burial">Beisetzung</label>
								<div class="col-sm-12">
									<datepicker id="burial" bootstrapStyling clear-button clear-button-icon="fa fa-trash" calendar-button calendar-button-icon="fa fa-calendar" name="burial" v-model="model.model.burial" required language="de" format="yyyy-MM-dd"></datepicker>
								</div>
							</custom-input>
						</div>

						<div class="col-md-3">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="mourning">Trauerfeier</label>
								<div class="col-sm-12">
									<datepicker id="mourning" bootstrapStyling clear-button clear-button-icon="fa fa-trash" calendar-button calendar-button-icon="fa fa-calendar" name="mourning" v-model="model.model.mourning" required language="de" format="yyyy-MM-dd"></datepicker>
								</div>
							</custom-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-3">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="urn_number">Ident.-Nummer</label>
								<div class="col-sm-12">
									<input id="urn_number" name="urn_number" class="form-control" v-model="model.model.urn_number" required>
								</div>
							</custom-input>
						</div>

						<div class="col-md-3">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="crematory">Krematorium</label>
								<div class="col-sm-12">
									<div class="input-group">
										<input id="crematory" name="crematory" class="form-control" required="required" v-model="model.model.crematory_name" readonly="readonly">
										<span class="input-group-addon addon-primary" @click="selectCrematory()"><i class="fa fa-pencil"></i></span>
										<router-link class="input-group-addon addon-success" :to="'/crematories/' + model.model.crematory_id" v-if="model.model.crematory_id > 0"><i class="fa fa-arrow-right"></i></router-link>
									</div>
								</div>
							</custom-input>
						</div>

						<div class="col-md-3">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="burial_type">Bestattungsart</label>
								<div class="col-sm-12">
<!--										<div class="input-group">
										<input id="burial_type" name="burial_type" class="form-control" required="required" v-model="model.model.burial_type" readonly="readonly">
										<span class="input-group-addon addon-primary" @click="selectBurialType()"><i class="fa fa-pencil"></i></span>
									</div> -->
									<select name="burial_type" id="burial_type" class="form-control" v-model="model.model.burial_type_id" :placeholder="model.model.burial_type">
										<option v-for="type in $store.getters.models('burial_types')" :value="type.id">{{ type.name }}</option>
									</select>
								</div>
							</custom-input>
						</div>

						<div class="col-md-3">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="undertaker">Bestatter</label>
								<div class="col-sm-12">
									<div class="input-group">
										<input id="undertaker" name="undertaker" class="form-control" required="required" v-model="model.model.undertaker_name" readonly="readonly">
										<span class="input-group-addon addon-primary" @click="selectUndertaker()"><i class="fa fa-pencil"></i></span>
										<router-link class="input-group-addon addon-success" :to="'/undertakers/' + model.model.undertaker_id" v-if="model.model.undertaker_id > 0"><i class="fa fa-arrow-right"></i></router-link>
									</div>
								</div>
							</custom-input>
						</div>
					</div>

					<div class="row">
						<div class="form-group">
							<div class="col-lg-12 text-center" v-if="!IsModal">
								<a href="/deceaseds/" class="hidden-sm hidden-xs"><button class="btn btn-success">Zur Liste</button></a>
								<button v-if="validModel" class="btn btn-primary" @click="saveDeceased()">Speichern</button>
							</div>
							<div class="col-lg-12 text-center" v-if="IsModal">
								<button :disabled="!validModel" class="btn btn-primary" @click="emitDeceased()">Speichern</button>
							</div>
						</div>
					</div>
				</div>

				<div class="row" v-show="model.model.id > 0" v-if="!IsModal">
					<div class="col-lg-12">
						<div class="col-lg-12">
							<ul class="nav nav-tabs responsive-tabs">
								<li class="active"><a href="#addresses">Letzte bekannte Adressen</a></li>
								<li><a href="#customers">Ansprechpartner</a></li>
								<li><a href="#graves">Grabstätten</a></li>
							</ul>

							<div class="tab-content col-lg-12">
								<div class="tab-pane active" id="addresses">
									<custom-table :cols="addresses.cols" :src-model="model.addresses" add delete edit nosort @add="addAddress" @edit="editAddress" @delete="deleteAddress"></custom-table>
								</div>

								<div class="tab-pane" id="customers">
									<custom-table :cols="customers.cols" :src-model="model.customers" add delete nosort select="/customers/{:customer_id}" @add="addCustomer" @delete="deleteCustomer" :default-sort="defSort"></custom-table>
								</div>

								<div class="tab-pane" id="graves">
									<custom-table :cols="graveCols" :src-model="model.graves" add edit delete nosort select="/graves/{:grave_id}" @add="addGrave" @edit="editGrave" @delete="deleteGrave"></custom-table>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>

			<custom-message ref="messenger"></custom-message>

		</div>

		<!-- Adressen -->
		<custom-modal ref="addressModal" title="Adresse hinzufügen" ok-text="Speichern" cancel-text="Abbrechen" ok-style="btn btn-primary" cancel-style="btn btn-default">
			<address-content ref="newAddress"></address-content>
		</custom-modal>

		<custom-modal-old v-if="visibleModal === 'deleteaddresses'" title="Adresse löschen" ok-text="Löschen" cancel-text="Abbrechen" cancel-style="btn btn-primary" @ok="confirmDeleteRelation('addresses')" @cancel="visibleModal = ''" ok-style="btn btn-danger">
			<strong>Sind Sie sicher, dass Sie diese Adresse entfernen möchten?</strong>
		</custom-modal-old>

		<!-- Bestatter -->
		<custom-modal-old v-if="visibleModal === 'selectundertakers'" title="Bestatter auswählen" @cancel="visibleModal = ''">
			<div class="row">
				<div class="col-lg-12">
					<custom-table row-add @rowAdd="pickUndertaker" :src-model="$store.getters.models('undertakers')" :cols="[{name: 'Name', json: 'name', 'type': 'text'}]" store="undertakers" search :default-sort="defSort"></custom-table>
				</div>
			</div>
		</custom-modal-old>

		<!-- Krematorium -->
		<custom-modal-old v-if="visibleModal === 'selectcrematories'" title="Krematorium auswählen" @cancel="visibleModal = ''">
			<div class="row">
				<div class="col-lg-12">
					<custom-table row-add @rowAdd="pickCrematory" :src-model="$store.getters.models('crematories')" :cols="[{name: 'Name', json: 'name', 'type': 'text'}]" store="crematories" search :default-sort="defSort"></custom-table>
				</div>
			</div>
		</custom-modal-old>

		<!-- Grab -->
		<custom-modal ref="graveModal" title="Grabstätte hinzufügen">
			<div class="row">
				<div class="col-lg-10">
					<custom-input title="Grab">
						<custom-table row-add @rowAdd="saveGrave" :src-model="$store.getters.models('graves')" :cols="graveCols" store="graves" search :default-sort="graveSort"></custom-table>
					</custom-input>
				</div>

				<div class="col-lg-2">
					<custom-input title="Von">
						<datepicker bootstrapStyling calendar-button calendar-button-icon="fa fa-calendar" name="from" v-model="graves.model.from" required language="de" format="yyyy-MM-dd"></datepicker>
					</custom-input>

					<custom-input title="Bis">
						<datepicker bootstrapStyling calendar-button calendar-button-icon="fa fa-calendar" name="until" v-model="graves.model.until" required language="de" format="yyyy-MM-dd"></datepicker>
					</custom-input>
				</div>
			</div>
		</custom-modal>

		<custom-modal ref="graveEditModal" title="Grabstätte bearbeiten" ok-text="Aktualisieren" cancel-text="Abbrechen" cancel-style="btn btn-default">
			<custom-input title="Von">
				<datepicker bootstrapStyling calendar-button calendar-button-icon="fa fa-calendar" name="from" v-model="graves.model.from" required language="de" format="yyyy-MM-dd"></datepicker>
			</custom-input>

			<custom-input title="Bis">
				<datepicker bootstrapStyling calendar-button calendar-button-icon="fa fa-calendar" name="until" v-model="graves.model.until" required language="de" format="yyyy-MM-dd"></datepicker>
			</custom-input>
		</custom-modal>

		<custom-modal-old title="Grab entfernen" v-if="visibleModal === 'deletegraves'" ok-text="Löschen" cancel-text="Abbrechen" @ok="confirmDeleteRelation('graves')" @cancel="visibleModal = ''" ok-style="btn btn-danger">
			<strong>Sind Sie sicher, dass Sie das Grab entfernen möchten?</strong>
		</custom-modal-old>

		<!-- Ansprechpartner -->
		<custom-modal ref="customerAddModal" title="Ansprechpartner hinzufügen">
			<tabs>
				<tab header="Hinzufügen">
					<custom-table row-add @rowAdd="storeCustomer" :src-model="$store.getters.models('customers')" search :cols="customerCols" :default-sort="defSort"></custom-table>
				</tab>

<!--				<tab header="Anlegen">
					<div class="row">
						<div class="col-lg-12">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="firstname">Vorname</label>
								<div class="col-sm-12">
									<input name="firstname" class="form-control" v-model="customers.model.firstname" required>
								</div>
							</custom-input>

							<custom-input inline>
								<label class="col-sm-12 control-label" for="lastname">Nachname</label>
								<div class="col-sm-12">
									<input name="lastname" class="form-control" v-model="customers.model.lastname" required>
								</div>
							</custom-input>
						</div>
					</div>
				</tab> -->
			</tabs>

			<!-- <div class="row">
				<div class="col-lg-12">
					<button class="btn btn-default btn-sm" @click="addCustomerMode = 'relation'">Hinzufügen</button>
					<button class="btn btn-default btn-sm" @click="addCustomerMode = 'new'">Anlegen</button>
				</div>
			</div>

			<div class="row">
				<div class="col-lg-12">
					<custom-table v-if="addCustomerMode === 'relation'" row-add @rowAdd="selectCustomer" :src-model="$store.getters.models('customers')" search :cols="customerCols" :default-sort="defSort"></custom-table>

					<div v-if="addCustomerMode === 'new'">
					</div>
				</div>
			</div> -->
		</custom-modal>

		<custom-modal-old title="Nutzungsberechtigten entfernen" v-if="visibleModal === 'deletecustomers'" ok-text="Löschen" cancel-text="Abbrechen" @ok="confirmDeleteRelation('customers')" @cancel="visibleModal = ''" ok-style="btn btn-danger">
			<strong>Sind Sie sicher, dass Sie diesen Nutzungsberechtigten entfernen möchten?</strong>
		</custom-modal-old>

		<!-- Fehlermeldungen -->
		<custom-modal-old v-if="visibleModal === 'errSavingModel'" @ok="visibleModal = ''" ok-text="OK" @cancel="visibleModal = ''">
			Fehler beim Speichern des Kunden.
		</custom-modal-old>
	</div>
</div>
</template>

<script>
import CustomTable from 'components/custom-table.vue'
import CustomModal from 'components/custom-modal.vue'
import CustomModalOld from 'components/custom-modal-old.vue'
import CustomInput from 'components/custom-input.vue'
import CustomMessage from 'components/custom-message.vue'
import { isData } from 'root/tools.js'
import AddressContent from 'components/address-content.vue'
import { ModelListSelect } from 'vue-search-select'
import { tabs, tab, tabGroup } from 'vue-strap'

import Datepicker from 'vuejs-datepicker'

import CustomersModel from 'models/customers.js'
import AddressesModel from 'models/addresses.js'
import GravesModel from 'models/graves.js'
import DeceasedsModel from 'models/deceaseds.js'

import modelTools from 'functions/models.js'
import relationTools from 'functions/relations.js'
import graveTools from 'functions/grave.js'
import customerTools from 'functions/customer.js'
import addressTools from 'functions/address.js'

import store from 'root/store.js'
import { authCheck } from 'functions/auth_check.js'

export default {
	beforeRouteEnter (to, from, next) {
		const route = authCheck('deceaseds')
		if (route === null) {
			next()
		} else {
			next(route)
		}
	},

	beforeRouteLeave(to, from, next) {
		if (to.path === '/'+this.model.name+'/new') {
			this.model.clear()
		}
		next()
	},

	props: {
		IsModal: {
			type: Boolean,
			default: false
		}
	},

	// data ist ein Abbild der aktuell auf der Seite verfügbaren Informationen
	data () {
		return {
			model: DeceasedsModel,
			graves: GravesModel,
			customers: CustomersModel,
			addresses: AddressesModel,

			// visibleModal: 'addgraves'
			visibleModal: '',

			graveCols: [
				{name: 'Name', json: 'name', type: 'text' },
				{name: 'Von', json: 'from', type: 'date', 'colCSS': 'hidden-xs'},
				{name: 'Bis', json: 'until', type: 'date'}
			],

			defSort: {col: 'id', order: 'asc'},
			graveSort: {col: 'id', order: 'asc'},

			customerCols: [
				{name: 'Vorname', json: 'firstname', type: 'text'},
				{name: 'Nachname', json: 'lastname', type: 'text'}
			],

			addCustomerMode: 'relation',
			addGraveMode: 'relation',
			addAddressMode: 'add'
		}
	},

	activated () {
		this.model.clearModel()
		this.model.model.id = parseInt(this.$route.params.deceased_id)
		if (isNaN(this.model.model.id)) {
			this.model.model.id = 0
		}

		$('.responsive-tabs').responsiveTabs({
			accordionOn: ['xs', 'sm'] // xs, sm, md, lg
		})

		this.$store.dispatch('loadModels', this.model.relations)
		.then(() => {
			this.$store.dispatch('loadModel', 'deceaseds')
			.then(() => {
				var model = this.$store.getters.model('deceaseds', this.model.model.id)
				this.model.copy(model)

				this.$store.dispatch('loadRelation', {basis: this.model, relation: 'graves'})
				.then(data => this.initRelation('graves', data))

				this.$store.dispatch('loadRelation', {basis: this.model, relation: 'customers'})
				.then(data => this.initRelation('customers', data))

				this.$store.dispatch('loadRelation', {basis: this.model, relation: 'addresses'})
				.then(data => this.initRelation('addresses', data))
			})
		})
	},

	computed: {
		validModel () {
			console.log("BD", this.model.model.birthday, "DD", this.model.model.dyingday)

			const FirstnameOK = typeof this.model.model.firstname === "string" && this.model.model.firstname.trim() !== ""
			const LastnameOK = typeof this.model.model.lastname === "string" && this.model.model.lastname.trim() !== ""
			const GenderOK = typeof this.model.model.gender === "number" && this.model.model.gender > 0 && Math.floor(this.model.model.gender) === this.model.model.gender
			const BirthdayOK = isData(this.model.model.birthday)
			const DyingdayOK = isData(this.model.model.dyingday)

			return FirstnameOK && LastnameOK && GenderOK && BirthdayOK && DyingdayOK
		},

		pageheader () {
			let model
			let name


			if (this.model.model.id === 0) {
				return 'Neuen Verstorbenen erfassen'
			} else {
				model = this.$store.getters.model('deceaseds', this.model.model.id)
				name = model.firstname + ' ' + model.lastname

				return 'Verstorbenen "' + name.trim() + '" verwalten'
			}
		}
	},

	components: {
		CustomTable,
		CustomModal,
		CustomModalOld,
		CustomInput,
		CustomMessage,
		Datepicker,
		ModelListSelect,
		AddressContent,
		tabs,
		tabGroup,
		tab
	},

	methods: {
		// Tools des Models
		saveModel: modelTools.save,

		// Beziehungen zwischen Models
		initRelation: relationTools.init,
		editRelation: relationTools.edit,
		deleteRelation: relationTools.delete,
		addRelation: relationTools.add,
		saveRelation: relationTools.save,
		confirmDeleteRelation: relationTools.confirmDelete,

		// Grab speziefische Methoden
		editGrave (aModel) {
			this.graves.copy(aModel)
			this.$refs.graveEditModal.open()
			.then(() => {
				this.saveRelation('graves')
			})
		},

		deleteGrave: graveTools.delete,

		addCustomer () {
			this.$refs.customerAddModal.open()
		},

		storeCustomer (aModel) {
			axios.post("/api/deceaseds/" + this.model.model.id + "/customers/", {customer_id: aModel.id, deceased_id: this.model.model.id})
			.then(() => {
				this.$refs.customerAddModal.cancel()
			})
		},

		// Grab speziefische Methoden
		addressModal () {
			this.$refs.addressModal.open( () => {
				// Callback um zzu prüfen ob das Modal geschlossen werden kann
				if (this.$refs.newAddress.model.model.street.trim() === "") {
					return false
				}

				if (this.$refs.newAddress.model.model.number.trim() === "") {
					return false
				}

				if (this.$refs.newAddress.model.model.zip.trim() === "") {
					return false
				}

				if (this.$refs.newAddress.model.model.city.trim() === "") {
					return false
				}

				return true
			})
			.then(() => {
				this.saveRelation('addresses')
			})
			.catch(() => {
				// Erfolgloses schließen
				console.log("CANCEL")
			})
		},

		addAddress () {
			this.addresses.clear()
			this.addressModal()
		},

		// Adressen speziefische Methoden
		editAddress (aModel) {
			this.addresses.copy(aModel)
			this.addressModal()
		},

		deleteAddress: addressTools.delete,

		// Nutzungsberechtigten speziefische Methoden
		editCustomer: customerTools.edit,
		deleteCustomer: customerTools.delete,

		emitDeceased () {
			this.$emit("save", this.model)
		},

		selectUndertaker () {
			this.visibleModal = 'selectundertakers'
		},

		pickUndertaker (aModel) {
			this.model.model.undertaker_id = aModel.id
			this.model.model.undertaker_name = aModel.name
			this.visibleModal = ''
		},

		selectCrematory () {
			this.visibleModal = 'selectcrematories'
		},

		pickCrematory (aModel) {
			this.model.model.crematory_id = aModel.id
			this.model.model.crematory_name = aModel.name
			this.visibleModal = ''
		},

		saveModelModal () {
			console.log('Speichere Verstorbenen');
		},

		saveGrave (aModel) {
			this.graves.model.name = aModel.id + ': Dummy'
			this.graves.model.id = 0
			this.saveRelation('graves')
			this.visibleModal = ''
			this.$refs.graveModal.cancel()
		},

		updateGrave () {
			this.graves.model.name = this.graves.model.grave_id + ': Dummy'
			this.saveRelation('graves')
			this.visibleModal = ''
		},

		saveDeceased () {
			this.saveModel()
			.then(id => {
				this.model.model.id = id
				this.$router.replace("/deceaseds/" + id)
				this.$refs.messenger.display()
			})
			.catch(id => {
				this.model.model.id = id
			})
		},

		selectCustomer (aModel) {
			this.customers.copy(aModel)
			this.customers.model.name = aModel.id + ': Dummy'
			this.customers.model.id = 0
			this.saveRelation('customers')
			this.visibleModal = ''
		},

		newCustomer () {
			this.saveModel(this.customers)
			.then(response => {
				this.customers.model.name = response + ': Dummy'
				this.customers.model.customer_id = response
				this.customers.model.id = 0
				this.saveRelation('customers')
			})
			.catch(err => {
				console.log(err)
			})
		},

		addGrave () {
			$('.responsive-tabs').responsiveTabs({
				accordionOn: ['xs', 'sm'] // xs, sm, md, lg
			})

			this.$refs.graveModal.open()
		}

	}
}
</script>

<style>
.form-horizontal .control-label, .control-label {
	text-align: left;
}

.main-area {
	background-color: rgba(0, 0, 0, 0.0);
}
</style>



// WEBPACK FOOTER //
// DeceasedEdit.vue?2c56d0be